import { FaroInsightsWrapper } from "@/grafana-faro"
import { CopilotTag } from "@/modules/patients/components/copilot-tag"
import {
  SuggestedMedication,
  useHealthInformationCopilotContext,
} from "@/modules/patients/contexts/health-information-copilot-context"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { useDrawerStore } from "@/stores/useDrawerStore"

export const MedicationCopilots = ({
  onOpenMedicationDrawer,
  patientId,
  currentMedications,
}: {
  onOpenMedicationDrawer: () => void
  patientId: string
  currentMedications: Array<{ name: string; id: string }>
}) => {
  const appointmentId = useAppointmentParam()
  const copilotMedications = useHealthInformationCopilotContext((v) => v.medications.data)
  const setSelectedCopilotMedication = useHealthInformationCopilotContext((v) => v.medications.setSelected)
  const hideCopilotMedication = useHealthInformationCopilotContext((v) => v.medications.hide)
  const drawerName = useDrawerStore((state) => state.drawerName)

  const handleOpenMedicationDrawer = (medication: SuggestedMedication) => {
    setSelectedCopilotMedication(medication)
    hideCopilotMedication(medication)
    if (drawerName !== "MedicationDrawer") {
      onOpenMedicationDrawer()
    }
  }

  const filteredCopilotMedications = copilotMedications.filter(
    (copilot) => !currentMedications.some((medication) => medication.name === copilot),
  )

  return (
    filteredCopilotMedications.length > 0 && (
      <div className="flex w-full flex-wrap items-center gap-2" data-testid="medication-copilot-tag-section">
        {filteredCopilotMedications.map((copilot) => (
          <CopilotTag
            key={copilot}
            id={copilot}
            name={copilot}
            onCancel={() => {
              hideCopilotMedication(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_medication_reject", {
                medicationName: copilot,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
            onApprove={() => {
              handleOpenMedicationDrawer(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_medication_accept", {
                medicationName: copilot,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
          />
        ))}
      </div>
    )
  )
}
